import React from 'react';
import { ExtraProps } from 'react-markdown';

const ParagraphRenderer = ({
  node,
  ...props
}: React.DetailedHTMLProps<React.HTMLAttributes<HTMLParagraphElement>, HTMLParagraphElement> & ExtraProps) => (
  <p className="my-4 only:my-0 w-full" {...props} />
);

export default ParagraphRenderer;
